<template>
  <div class="login-flow">
    <img class="image-container" :src="require('@/assets/hero-login.svg')">
    <div class="content">
      <enter-phone-number :next="redirectToEnterCode"/>
    </div>
    <login-support-footer-positioned/>
  </div>
</template>

<script>

import LoginSupportFooterPositioned from '@/base-components/LoginSupportFooterPositioned';
import Segment from '../../../../Segment';
import router from '../../../../router';
import EnterPhoneNumber from './steps/EnterPhoneNumber.vue';

export default {
  name: 'LoginEnterPhoneNumber',
  components: {
    LoginSupportFooterPositioned,
    EnterPhoneNumber,
  },
  created() {
    Segment.trackUserGot('LoginEntered');
  },
  methods: {
    async redirectToEnterCode(phoneNumber) {
      const queryParams = { ...this.$route.query, phoneNumber };
      await router.push({ path: '/login-enter-code', query: queryParams });
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-flow {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }
  }
</style>
